import {
  api
} from '@/api/index.js';
import {
  store
} from '../index';
const state = {
  selectedTask: {},
  suggestedUsers: [],
  suggestedTeams: [],
  suggestedTags: [],
  suggestedProjects: [],
};
const actions = {
  cleanSuggestions() {
    store.commit('cleanSuggestions');
  },
  cleanSuggestedTags() {
    store.commit('cleaneSuggestedTags');
  },
  cleanSuggestedProjects() {
    store.commit('cleaneSuggestedProjects');
  },
  async suggestTags(commit, params) {
    let res = await api.suggestTags(params.pro_id, params.tagFor, params.searchStr);
    if (!res.data) return;
    store.commit('setSuggestedTags', {
      suggestions: res.data.data
    });
  },
  async refreshSuggestions(commit, params) {
    var searchText = params.searchText;
    var pro_id = params.pro_id;
    let res = await api.refreshSuggestions(searchText, pro_id);
    if (!res) return;
    store.commit('setSuggestions', res);
  },
  selectTask(commit, params) {
    api.selectTask(params.id);
  },
};

const mutations = {
  setSuggestedTeams: (state, params) => {
    state.suggestedTeams = params.data.data;
  },
  cleaneSuggestedTeams: () => {
    state.suggestedTeams = [];
  },
  cleaneSuggestedProjects: () => {
    state.suggestedProjects = [];
  },
  setSuggestedTags: (state, params) => {
    state.suggestedTags = params.suggestions;
  },
  cleaneSuggestedTags: () => {
    state.suggestedTags = [];
  },
  cleanSuggestions: () => {
    state.suggestedUsers = [];
  },
  setSuggestions: (state, params) => {
    state.suggestedUsers = params.data.data;
  },
  setSuggestedProjects: (state, params) => {
    state.suggestedProjects = params.data.data;
  },
  changeSelectedTask: (state, params) => {
    store.state.selectedTask = params.selectedTask;
  },
};

const getters = {
  getSelectedTask: () => {
    return store.state.selectedTask;
  },
  getSuggestedUsers: state => {
    return state.suggestedUsers;
  },
  getSuggestedTeams: state => {
    return state.suggestedTeams;
  },

};
export default {
  actions,
  mutations,
  getters,
  state
};



// WEBPACK FOOTER //
// ./src/store/modules/work.js